import * as React from 'react';
import { useState, useRef } from 'react';
import { GridTable } from 'olive-react-myoneui';

import FilesNameTemplate from './grid-table/FilesNameTemplate';
import CategoriesTemplate from './grid-table/FileTypeTemplate';
import CreatedByTemplate from './grid-table/CreatedByTemplate';
import CreatedDateTemplate from './grid-table/CreatedByTemplate';
import FileTags from './grid-table/FileTags';
import ActionBtnsTemplate from './grid-table/ActionBtnsTemplate';
import PaginationTemplate from './grid-table/PaginationTemplate';

function FilesGridTable({ items, categories, toggleBookMark, handleDropdownClick }) {
  const tableManager = useRef(null);
  const [filter] = useState(null);

  const setTableManager = (tm) => (tableManager.current = tm);


  if(items && items.length === 0) return null;
  items = items.map((item) => {
    item.i_category_name    = item.i_document_type ? categories.find(cat => cat.id == item.i_document_type).name: '';
    item.file_created_date  = item.shared_by ? item.shared_by.created_date : item.updated_date;
    item.file_shared_by     = item.shared_by ? item.shared_by.shared_name: '';
    item.file_action        = ['Download'];
    if(item.share_permission === "1") {
      item.file_action.push("Share");
    }
    if(item.access_type === "1") {
      item.file_action.push("Edit");
    }
    item.toggleBookMark     = toggleBookMark;
    item.handleDropdownClick= handleDropdownClick;
    return item;
  });
  // Files column data
  const columnData = [
    {
      id: 1,
      field: 'i_item_name',
      className: 'rgt-border-line-left',
      visible: true,
      label: 'Name',
      width: '1.9fr',
      sortable: true,
      cellRenderer: (props) => <FilesNameTemplate {...props} />,
    },
    {
      id: 3,
      field: 'i_category_name',
      visible: true,
      label: 'Categories',
      width: '.5fr',
      sortable: true,
      cellRenderer: (props) => <CategoriesTemplate {...props} />,
    },
    {
      id: 4,
      field: 'i_document_tags',
      visible: true,
      label: 'Tags',
      width: '1fr',
      sortable: false,
      cellRenderer: (props) => <FileTags {...props} />,
    },
    {
      id: 5,
      field: 'file_created_date',
      visible: true,
      label: 'Shared On',
      width: '.5fr',
      sortable: true,
      cellRenderer: (props) => <CreatedDateTemplate {...props} /> ,
    },
    {
      id: 6,
      field: 'file_shared_by',
      visible: true,
      label: 'Shared by',
      width: '.5fr',
      sortable: true,
      cellRenderer: (props) => <CreatedByTemplate {...props} />,
    },
    {
      id: 7,
      field: 'file_action',
      visible: true,
      label: 'Actions',
      width: '.5fr',
      sortable: false,
      cellRenderer: (props) => <ActionBtnsTemplate {...props} />,
    },
  ];
  return (
    <>
    <div className="grid-wrapper">
      <GridTable
        className="program-grid grid-insert-files rgt-checkbox-dropdown-align grid-docs-height"
        highlightSearch={false}
        columns={columnData}
        rows={items}
        onSelectedRowsChange={(a) => console.log('selected row changes id:', a)}
        onPageChange={(page) => console.log('page Chagne ', page)}
        onPageSizeChange={(size) => console.log('page size', size)}
        onRowClick={(a) => console.log('onRowClick:', a)}
        filter={filter}
        onLoad={setTableManager}
        components={{ Footer: PaginationTemplate }}
      />
    </div>
    </>
  );
}

export default FilesGridTable;
